<template>
    <div
        class="icon-btn-root noselect"
        :class="{
            'primary-color': color === 'primary',
            'secondary-color': color === 'secondary',
        }"
        @click="handleClick"
    >
        <BaseIcon :name="name" :size="size" />
    </div>
</template>

<script>
export default {
    name: 'IconBtn',
    props: {
        name: {
            type: String,
            required: true,
        },
        size: String,
        color: String,
    },
    methods: {
        handleClick() {
            this.$emit('click');
        },
    },
};
</script>

<style scoped>
.icon-btn-root {
    display: flex;
    align-items: center;
    padding: 4px;
    border-radius: 50%;

    cursor: pointer;
}

.icon-btn-root:hover {
    background-color: rgba(0, 0, 0, 0.03);
}

.icon-btn-root:active {
    background-color: rgba(0, 0, 0, 0.06);
}
</style>
